var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "undo_svg2__a",
    x1: 53.1,
    x2: 205.1,
    y1: 145.4,
    y2: 50.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 64.5H33l35.1-35.1c3.7-3.7 3.7-9.9 0-13.7-3.7-3.7-9.9-3.7-13.7 0L2.8 67.3C-.9 71-.9 77.2 2.8 81l51.6 51.6c1.9 1.9 4.4 2.8 6.8 2.8s4.9-.9 6.8-2.8c3.7-3.7 3.7-9.9 0-13.7L32.9 83.8h79.9c37.4 0 67.8 30.5 67.8 67.8v25.8c0 5.3 4.4 9.7 9.7 9.7s9.7-4.4 9.7-9.7v-25.8c0-48-39.1-87.1-87.1-87.1",
    style: {
      fill: "url(#undo_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgUndo;